export enum SensorType {
  InletTemp = 0,
  BeanTemp = 1,
  DrumTemp = 2,
  ExhaustTemp = 3,
  Pressure = 4,
}
